import type { SVGProps } from 'react';

export const User = (props: SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M12.06 13c2.79 0 5.06-2.24 5.06-5s-2.26-5-5.06-5S7 5.24 7 8s2.26 5 5.06 5zm0-8c1.67 0 3.04 1.35 3.04 3s-1.36 3-3.04 3-3.04-1.35-3.04-3 1.37-3 3.04-3zM15 15H9c-3.31 0-6 2.69-6 6h18c0-3.31-2.69-6-6-6zm-9.46 4c.69-1.19 1.99-2 3.46-2h6a4 4 0 0 1 3.46 2H5.54z' />
    </svg>
);
